/* eslint-disable jsx-a11y/aria-role */
import React, { Fragment, PureComponent } from 'react'
import {
    Route,
} from 'react-router-dom'

import QListSearch from './QListSearch'
import QListSearchStore from './QListSearchStore'
import QuestionLibrary from './QuestionLibrary'
import AccessRights from '../components/AccessRights'

import './QuestionLibrary.scss'

class MandatoryQuestions extends PureComponent {
    constructor(props) {
        super(props)

        this.qListSearchStore = new QListSearchStore(props.store)
    }

    render() {
        const { store, location } = this.props
        const { qListSearchStore } = this
        return (
            <Fragment>
                <Route
                    exact
                    path="/mandatoryquestions/select/"
                    render={({ match, history }) => (
                        <AccessRights
                            store={store}
                            deniedRedirect="/home/e/01011"
                            role="100|110|120|130"
                        >
                            <QListSearch
                                store={store}
                                qListSearchStore={qListSearchStore}
                                location={location}
                                history={history}
                                match={match}
                            />
                        </AccessRights>
                    )}
                />
                <Route
                    path="/mandatoryquestions/setup/:oid/:rid"
                    render={({ match, history }) => (
                        <AccessRights
                            store={store}
                            deniedRedirect="/home/e/01011"
                        >
                            <QuestionLibrary
                                store={store}
                                qListSearchStore={qListSearchStore}
                                rid={parseInt(match.params.rid, 10)}
                                oid={parseInt(match.params.oid, 10)}
                                history={history}
                                match={match}
                                allowInherit
                            />
                        </AccessRights>
                    )}
                />
            </Fragment>
        )
    }
}

export default MandatoryQuestions
